const genderIcons: { [key: string]: string } = {
  female: '♀️',
  male: '♂️',
};

const countryFlags: { [key: string]: string } = {
  es_ES: '🇪🇸',
  en_US: '🇺🇸',
  en_GB: '🇬🇧',
  pt_BR: '🇧🇷',
  fr_FR: '🇫🇷',
  it_IT: '🇮🇹',
  de_DE: '🇩🇪',
  es_AR: '🇦🇷',
  pt_PT: '🇵🇹',
};

const voices = [
  { id: '6', name: 'Maria', gender: 'female', locales: ['es_ES'] },
  { id: '27', name: 'Ana', gender: 'female', locales: ['es_ES'] },
];

export function generateVoiceDropdownOptions() {
  return voices.map((voice) => {
    const genderIcon = genderIcons[voice.gender] || '';
    const flags = voice.locales.map((locale) => countryFlags[locale] || '').join(' ');
    const label = `${genderIcon} ${voice.name} (${flags})`;

    return {
      value: voice.id,
      label,
    };
  });
}
